import i18n from '@/i18n';
import { carModels } from '@/utils/permission';
import { PREFIX } from '@/utils/constants';
const Layout = () => import('@/layouts/main.vue');
const CarModels = () => import('./views/Index.vue');

export default [
  {
    path: 'car-models',
    component: Layout,
    meta: { authRequired: true, header: true },
    children: [
      {
        path: '',
        name: `${PREFIX.INSPECTOR}.CarModels`,
        component: CarModels,
        meta: {
          title: i18n.global.t('carModels.carModels'),
          permission: { module: carModels.module, key: carModels.showAll },
        },
      },
    ],
  },
];
